import { useEffect } from 'react';

function useUnmount(callback) {
  useEffect(function () {
    return callback;
  }, []);
}

export { useUnmount };